import React from 'react';
import { Tooltip } from 'antd';
import { Colors } from '@common/tokens';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';
import { RenderFunction, TooltipPropsWithTitle } from 'antd/lib/tooltip';

type Props = TooltipPropsWithTitle & {
  title: string | React.ReactNode | RenderFunction;
  size?: SizeProp;
  leftOffset?: number;
  icon?: IconProp;
  iconColor?: string;
};

export const InfoTooltip: React.FC<Props> = ({
  size = 'lg',
  leftOffset = 18,
  icon = faCircleInfo,
  iconColor = Colors.midnightLightest,
  ...props
}) => (
  <Tooltip {...props}>
    {/* @deprecated: replace by the Icon component instead */}
    <FontAwesomeIcon
      className="wk-info-tooltip"
      icon={icon}
      color={iconColor}
      size={size}
      style={{ marginLeft: leftOffset }}
    />
  </Tooltip>
);
